module.exports = __webpack_public_path__ + "static/media/guitar2.4a79e25a.svg";